<template>
  <div class="view">
    <div class="content">
      <pull-refresh v-model="refreshing" @refresh="onRefresh">
        <list
          class="cont-box"
          v-model="loading"
          @load="getlistdata"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
        >
          <div
            class="item-box"
            @click="toDetail(item)"
            v-for="item in list"
            :key="item.id"
          >
            <!-- <div class="item-box"> -->
            <div class="item-left" :class="'item-left-' + item.taskSource">
              {{ taskSourceMap[item.taskSource] || '未知' }}
            </div>
            <div class="item-center">
              <div class="item-title">
                <span class="title-name item-title">
                  <span class="van-ellipsis"> {{ item.name }}</span>
                  <tag
                    v-if="item.result || item.result === 0"
                    :type="item.result != 1 ? 'danger' : 'primary'"
                    plain
                    style="margin: 0 6px; flex-shrink: 0"
                    >{{
                      ['审核中', '审核通过', '审核不通过'][item.result]
                    }}</tag
                  >
                </span>
                <span class="title-time">{{
                  item.startTime.split(' ')[0]
                }}</span>
              </div>
            </div>
            <icon class="item-right-icon" name="arrow" />
          </div>
        </list>
      </pull-refresh>
    </div>
  </div>
</template>

<script>
import { Cell, Icon, List, PullRefresh, Tag } from 'vant'
import application from '@api/application'

export default {
  name: 'messterList',
  components: {
    Cell,
    List,
    Icon,
    PullRefresh,
    Tag,
  },
  props: {
    active: {
      type: String,
      default() {
        return 'toRead'
      },
    },
  },
  data() {
    return {
      title: this.$route.query.title,
      key: this.$route.query.key,
      token: this.$store.state.user.token,
      taskSourceMap: {
        0: '工程',
        1: '设计',
        2: '安全',
        3: '质量',
        4: '物资',
        5: '法务',
        6: '办公',
        7: '科技',
        8: '技术',
        9: '工会',
        10: '商务',
        11: '纪检',
        12: '车辆',
        13: '党群'
      },
      query: {
        pageNo: 1,
        pageSize: 5,
      },

      list: [],
      error: false,
      loading: false,
      finished: false,
      refreshing: false,
      columns: [],
      screen: this.$route.query.screen,
      qualityquery: this.$store.state.project.qualityquery,
    }
  },
  created() {
    // if (this.$store.state.project.key === 0) {
    //
    // }  else if (this.$store.state.project.key === 1){
    //
    // }
  },
  computed: {
    currentList() {
      return this.active
    },
    userInfo() {
      return localStorage.getItem('vuex')
        ? JSON.parse(localStorage.getItem('vuex')).user.userInfo
        : {}
    },
    users() {
      // JSON.parse(localStorage.getItem("vuex")).user.userInfo.userId
      const userList =
        (this.userInfo &&
          this.userInfo.posts &&
          this.userInfo.posts.map((item) => item.id)) ||
        []

      userList.push(this.userInfo.userId)
      return userList
    },
  },
  methods: {
    getlistdata(type = 'add') {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      if (type == 'new') {
        this.list = []
        this.query.pageNo = 1
        this.loading = true
        this.finished = false
      }
      this.query.startUserId = this.userInfo.userId
      this.query.run = this.currentList === 'toRead' ? 0 : 1
      // return
      application
        .messageMyCountNum(this.query)
        .then((res) => {
          this.loading = false
          if (res.code == 200) {
            this.list = this.list.concat(res.data)
            if (this.list.length === res.totalSize) {
              this.finished = true
              return
            }
            this.query.pageNo++
          } else {
            this.error = true
            this.loading = false
            this.finished = true
          }
        })
        .catch((err) => {
          this.loading = false
          this.error = true
        })
    },
    searchLoad() {
      this.getlistdata('new')
    },
    onRefresh() {
      this.getlistdata('new')
      this.finished = false
      this.loading = true
    },
    toDetail(val) {
      const params = {
        id: val.businessId,
        name: val.name,
      }
      this.$router.push({
        path: '/application/myMessages/detail',
        query: params,
      })
      // console.log(val)
      return
    },
  },
  mounted() {
    // if(this.screen) {
    //     Object.assign(this.query.query, this.$store.state.project.qualityquery);
    // }
    // project.qualitytype({query:{labelType: '3'}}).then(res=> {
    //     if(res.code === 200){
    //         this.approvallist = [{name:'全部',id:''}].concat(res.data);
    //     }else {
    //         this.$toast(res.message)
    //     }
    // });
  },
}
</script>

<style lang="scss" scoped>
.view {
  .content {
    padding-bottom: 50px;
    .cont-box {
      padding: 1rem;
      .item-box {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
        overflow: hidden;
        line-height: 2.4rem;
        min-height: 7.2rem;
        font-size: 1.4rem;
        position: relative;
        &:active {
          background-color: #f2f3f5;
        }
        &::after {
          right: 0 !important;
          left: 0 !important;
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          right: 1.6rem;
          bottom: 0;
          left: 1.6rem;
          border-bottom: 0.1rem solid #ebedf0;
          -webkit-transform: scaleY(0.5);
          transform: scaleY(0.5);
        }
        .item-left {
          box-shadow: 0px 0px 0px 0.8rem;
          // border: 8px solid indianred;
          width: 4rem;
          height: 4rem;
          line-height: 4rem;
          text-align: center;
          color: #fff;
          font-size: 1.6rem;
          border-radius: 100%;
          background: #169bd5;
          margin-right: 1.8rem;
          margin-left: 0.8rem;
        }
        .item-left-0 {
          background: rgba(39, 126, 208, 1);
          box-shadow: 0 0 0 0.8rem rgba(39, 126, 208, 0.5);
        }
        .item-left-1 {
          background: rgba(39, 126, 208, 1);
          box-shadow: 0 0 0 0.8rem rgba(39, 126, 208, 0.5);
        }
        .item-left-2 {
          background: rgba(112, 182, 3, 1);
          box-shadow: 0 0 0 0.8rem rgba(112, 182, 3, 0.5);
        }
        .item-left-3 {
          background: rgba(245, 154, 35, 1);
          box-shadow: 0 0 0 0.8rem rgba(245, 154, 35, 0.5);
        }
        .item-left-4 {
          background: rgb(190, 121, 31);
          box-shadow: 0 0 0 0.8rem rgba(245, 154, 35, 0.5);
        }
        .item-left-5 {
          background: rgb(85, 50, 5);
          box-shadow: 0 0 0 0.8rem rgba(245, 154, 35, 0.5);
        }
        .item-left-6 {
          background: rgba(245, 154, 35, 1);
          box-shadow: 0 0 0 0.8rem rgba(245, 154, 35, 0.5);
        }
        .item-left-7 {
          background: rgb(190, 121, 31);
          box-shadow: 0 0 0 0.8rem rgba(245, 154, 35, 0.5);
        }
        .item-left-8 {
          background: rgb(85, 50, 5);
          box-shadow: 0 0 0 0.8rem rgba(245, 154, 35, 0.5);
        }
        .item-left-9 {
          background: rgba(112, 182, 3, 1);
          box-shadow: 0 0 0 0.8rem rgba(112, 182, 3, 0.5);
        }
        .item-center {
          flex: 1;
          overflow: hidden;
          .item-title {
            display: flex;
            .title-name {
              font-size: 1.6rem;
              width: calc(100% - 8rem);
              flex: 1;
            }
            .title-tag {
              border-radius: 4px;
              font-size: 1.2rem;
              line-height: 2.4rem;
              padding: 0 0.6rem;
              margin-right: 1rem;
              height: 2.4rem;
            }
            .title-tag-success {
              color: #02a7f0;
              border: 1px solid #02a7f0;
              background: #02a7f019;
            }
            .title-tag-error {
              color: #f5222d;
              border: 1px solid #ffa39e;
              background: #fef0ef;
            }
            .title-time {
              flex-shrink: 0;
              text-align: right;
              color: #999;
            }
          }
          .item-content {
            color: #999;
          }
          .item-subcontent {
            color: #999;
            font-size: 1.2rem;
          }
        }
        .item-right-icon {
          margin-left: 0.4rem;
          color: #969799;
        }
      }
    }
  }
}
</style>
